<div class="h-full flex flex-col">

  <!-- Header with mode tabs -->
  <div class="px-4 py-2 border-b border-gray-200 dark:border-gray-800 flex items-center gap-1">
    <button type="button" (click)="panelMode = 'field'"
      class="px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
      [class.bg-brand-500]="panelMode === 'field'"
      [class.text-white]="panelMode === 'field'"
      [class.text-gray-500]="panelMode !== 'field'"
      [class.dark:text-gray-400]="panelMode !== 'field'"
      [class.hover:bg-gray-100]="panelMode !== 'field'"
      [class.dark:hover:bg-gray-800]="panelMode !== 'field'">
      Campo
    </button>
    <button type="button" (click)="panelMode = 'design'"
      class="px-3 py-1.5 rounded-lg text-xs font-medium transition-colors"
      [class.bg-brand-500]="panelMode === 'design'"
      [class.text-white]="panelMode === 'design'"
      [class.text-gray-500]="panelMode !== 'design'"
      [class.dark:text-gray-400]="panelMode !== 'design'"
      [class.hover:bg-gray-100]="panelMode !== 'design'"
      [class.dark:hover:bg-gray-800]="panelMode !== 'design'">
      Diseño
    </button>
  </div>

  <!-- Design panel -->
  @if (panelMode === 'design') {
    <div class="flex-1 overflow-y-auto px-4 py-4 space-y-5">
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Etiqueta del botón Enviar</label>
        <input type="text"
          [value]="submitButtonLabel"
          (input)="onSubmitLabelChange($any($event.target).value)"
          placeholder="Enviar"
          class="w-full px-3 py-2 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition" />
      </div>
      <div class="border-t border-gray-100 dark:border-gray-800 pt-4">
        <p class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-3">Colores y estilo</p>
        <app-style-config-editor
          [value]="styleConfig"
          (valueChange)="onStyleConfigChange($event)"
        />
      </div>
    </div>
  }

  @if (panelMode === 'field') {

  @if (!selectedField) {
    <div class="flex-1 flex flex-col items-center justify-center gap-2 p-6 text-center">
      <svg class="w-8 h-8 text-gray-300 dark:text-gray-600" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" d="M15.232 5.232l3.536 3.536m-2.036-5.036a2.5 2.5 0 113.536 3.536L6.5 21.036H3v-3.572L16.732 3.732z"/>
      </svg>
      <p class="text-sm text-gray-500 dark:text-gray-400">Selecciona un campo para editarlo</p>
    </div>
  } @else {
    <div class="flex-1 overflow-y-auto px-4 py-4 space-y-5" [formGroup]="form">

      <!-- Etiqueta (siempre visible) -->
      <div>
        <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Etiqueta</label>
        <input formControlName="label" type="text" placeholder="Ej. Nombre completo"
          class="w-full px-3 py-2 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition" />
      </div>

      <!-- Placeholder -->
      @if (showPlaceholder) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Placeholder</label>
          <input formControlName="placeholder" type="text" placeholder="Texto de ayuda en el campo"
            class="w-full px-3 py-2 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition" />
        </div>
      }

      <!-- Texto de ayuda -->
      @if (showHelpText) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-1.5">Texto de ayuda</label>
          <input formControlName="helpText" type="text" placeholder="Instrucción adicional para el usuario"
            class="w-full px-3 py-2 text-sm rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 focus:border-transparent transition" />
        </div>
      }

      <!-- Opciones (dropdown / checkboxes / radio) -->
      @if (hasOptions) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-2">Opciones</label>
          @if (isCatalogLocked) {
            <div class="rounded-lg border border-brand-200 dark:border-brand-800 bg-brand-50 dark:bg-brand-900/20 p-2.5 space-y-2">
              <div class="flex items-center gap-1.5 text-[11px] text-brand-700 dark:text-brand-400 font-medium">
                <svg class="w-3.5 h-3.5 flex-shrink-0" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 15v2m-6 4h12a2 2 0 002-2v-6a2 2 0 00-2-2H6a2 2 0 00-2 2v6a2 2 0 002 2zm10-10V7a4 4 0 00-8 0v4h8z"/>
                </svg>
                Sincronizado con <span class="font-semibold ml-0.5">{{ catalogLockedLabel }}</span>
              </div>
              <div class="space-y-1">
                @for (opt of options; track $index) {
                  <div class="px-2.5 py-1.5 text-xs rounded-lg bg-white dark:bg-gray-800 border border-gray-200 dark:border-gray-700 text-gray-500 dark:text-gray-400 select-none">
                    {{ opt.optionLabel }}
                  </div>
                }
              </div>
            </div>
          } @else {
            <div class="space-y-1.5">
              @for (opt of options; track $index; let i = $index) {
                <div class="flex items-center gap-1.5">
                  <input
                    type="text"
                    [value]="opt.optionLabel"
                    (input)="updateOption(i, 'optionLabel', $any($event.target).value)"
                    placeholder="Etiqueta"
                    class="flex-1 px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition"
                  />
                  <button (click)="removeOption(i)" class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-gray-400 hover:text-error-500 hover:bg-error-50 dark:hover:bg-error-500/10 transition-colors">
                    <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/></svg>
                  </button>
                </div>
              }
            </div>
            <button (click)="addOption()" class="mt-2 inline-flex items-center gap-1 text-xs font-medium text-brand-600 dark:text-brand-400 hover:text-brand-700 transition-colors">
              <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24"><path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/></svg>
              Añadir opción
            </button>
          }
        </div>
      }

      <!-- Ancho del campo -->
      @if (showColumnSpan) {
        <div>
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 mb-2">Ancho</label>
          <div class="grid grid-cols-3 gap-1.5">
            @for (opt of columnOptions; track opt.value) {
              <button type="button" (click)="form.patchValue({ columnSpan: opt.value })"
                class="py-1.5 rounded-lg text-xs font-medium transition-colors"
                [class.bg-brand-500]="form.value.columnSpan === opt.value"
                [class.text-white]="form.value.columnSpan === opt.value"
                [class.bg-gray-100]="form.value.columnSpan !== opt.value"
                [class.dark:bg-gray-800]="form.value.columnSpan !== opt.value"
                [class.text-gray-600]="form.value.columnSpan !== opt.value"
                [class.dark:text-gray-400]="form.value.columnSpan !== opt.value"
              >{{ opt.label }}</button>
            }
          </div>
        </div>
      }

      <!-- Requerido -->
      @if (showRequired) {
        <div class="space-y-3 pt-1">
          <label class="flex items-center justify-between cursor-pointer">
            <span class="text-sm text-gray-700 dark:text-gray-300">Requerido</span>
            <div class="relative">
              <input type="checkbox" formControlName="isRequired" class="sr-only peer">
              <div class="w-9 h-5 bg-gray-200 dark:bg-gray-700 peer-checked:bg-brand-500 rounded-full transition-colors peer-focus:ring-2 peer-focus:ring-brand-500/30"></div>
              <div class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform peer-checked:translate-x-4"></div>
            </div>
          </label>
        </div>
      }

      <!-- ¿Cómo se completa este campo? ───────────────────────────────────── -->
      @if (caps) {
        <div class="pt-1 border-t border-gray-200 dark:border-gray-800 space-y-2">
          <label class="block text-xs font-medium text-gray-600 dark:text-gray-400 pt-2">¿Cómo se completa este campo?</label>

          @if (caps.fillModes.length === 0) {
            <!-- Tipos que no admiten modo oculto (FILE_UPLOAD, RATING_NPS, GDPR_CONSENT) -->
            <div class="flex items-start gap-2 rounded-lg bg-gray-50 dark:bg-gray-800/60 border border-gray-200 dark:border-gray-700 px-3 py-2.5">
              <svg class="w-3.5 h-3.5 mt-0.5 flex-shrink-0 text-gray-400 dark:text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
              </svg>
              <p class="text-[11px] text-gray-600 dark:text-gray-400 leading-snug">
                Siempre lo <span class="font-medium text-gray-700 dark:text-gray-200">completa el visitante</span> directamente. No admite valor oculto ni parámetro de URL.
              </p>
            </div>

          } @else {
            <!-- Selector filtrado: solo los modos permitidos por este tipo de campo -->
            <div class="space-y-1.5">
              @for (m of filteredFillModes; track m.value) {
                <button type="button" (click)="onFillModeChange(m.value)"
                  class="w-full flex items-start gap-2.5 px-3 py-2 rounded-lg border text-left transition-colors"
                  [class.border-brand-500]="fillMode === m.value"
                  [class.bg-brand-50]="fillMode === m.value"
                  [class.dark:bg-brand-500/10]="fillMode === m.value"
                  [class.border-gray-200]="fillMode !== m.value"
                  [class.dark:border-gray-700]="fillMode !== m.value"
                  [class.hover:bg-gray-50]="fillMode !== m.value"
                  [class.dark:hover:bg-gray-800]="fillMode !== m.value">
                  <span class="mt-0.5 flex-shrink-0 w-3.5 h-3.5 rounded-full border-2 flex items-center justify-center"
                    [class.border-brand-500]="fillMode === m.value"
                    [class.border-gray-300]="fillMode !== m.value"
                    [class.dark:border-gray-600]="fillMode !== m.value">
                    @if (fillMode === m.value) {
                      <span class="w-1.5 h-1.5 rounded-full bg-brand-500"></span>
                    }
                  </span>
                  <span class="min-w-0">
                    <span class="block text-xs font-medium text-gray-800 dark:text-gray-200">{{ m.label }}</span>
                    <span class="block text-[11px] text-gray-400 dark:text-gray-500 leading-snug mt-0.5">{{ m.help }}</span>
                  </span>
                </button>
              }
            </div>

            <!-- Valor predeterminado (modo FIXED, sin catálogo) -->
            @if (isFixedMode) {
              <div class="pt-1">
                <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Valor predeterminado</label>
                <input formControlName="defaultFixedValue" type="text" placeholder="Ej. FACEBOOK"
                  class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
              </div>
            }

            <!-- Nombre del parámetro (modo URL) -->
            @if (isUrlMode) {
              <div class="pt-1">
                <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Nombre del parámetro</label>
                <input formControlName="urlParamName" type="text" placeholder="utm_source"
                  class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                <p class="text-[11px] text-gray-400 dark:text-gray-500 leading-relaxed mt-1">
                  Se toma de la URL de la página (ej. <span class="font-mono">?utm_source=facebook</span>).
                </p>
              </div>
            }
          }
        </div>
      }

      <!-- Reglas avanzadas (plegable) ─────────────────────────────────────── -->
      @if (showAdvancedSection) {
        <div class="pt-2 border-t border-gray-200 dark:border-gray-800">
          <button type="button" (click)="toggleAdvanced()"
            class="w-full flex items-center justify-between py-2 text-xs font-medium text-gray-700 dark:text-gray-300 hover:text-gray-900 dark:hover:text-white transition-colors">
            <span>Reglas avanzadas</span>
            <svg class="w-3.5 h-3.5 transition-transform" [class.rotate-180]="advancedOpen" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
            </svg>
          </button>

          @if (advancedOpen) {
            <div class="space-y-5 pt-2">

              <!-- Validación (solo tipos que la soportan) -->
              @if (caps?.validation !== 'none') {
                <div>
                  <p class="text-xs font-medium text-gray-600 dark:text-gray-400 mb-3">Validación</p>

                  @if (showTextValidation) {
                    <div class="space-y-3">
                      <div class="grid grid-cols-2 gap-2">
                        <div>
                          <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Mín. longitud</label>
                          <input type="number" min="0"
                            [value]="valMinLength ?? ''"
                            (change)="onValMinLengthChange($any($event.target).value)"
                            placeholder="—"
                            class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                        </div>
                        <div>
                          <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Máx. longitud</label>
                          <input type="number" min="0"
                            [value]="valMaxLength ?? ''"
                            (change)="onValMaxLengthChange($any($event.target).value)"
                            placeholder="—"
                            class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                        </div>
                      </div>
                      <div>
                        <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Patrón (regex)</label>
                        <input type="text"
                          [value]="valPattern"
                          (input)="onValPatternChange($any($event.target).value)"
                          placeholder="Ej. ^[A-Za-z]+"
                          [class.border-error-500]="regexPatternError"
                          class="w-full px-2.5 py-1.5 text-xs font-mono rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                        @if (regexPatternError) {
                          <p class="text-[10px] text-error-500 mt-1 flex items-center gap-1">
                            <span>⚠</span> {{ regexPatternError }}
                          </p>
                        } @else if (valPattern.trim()) {
                          <p class="text-[10px] text-emerald-500 dark:text-emerald-400 mt-1 flex items-center gap-1">
                            <span>✓</span> Patrón válido
                          </p>
                        }
                      </div>
                    </div>
                  } @else if (showNumberValidation) {
                    <div class="grid grid-cols-2 gap-2">
                      <div>
                        <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Valor mínimo</label>
                        <input type="number"
                          [value]="valMin ?? ''"
                          (change)="onValMinChange($any($event.target).value)"
                          placeholder="—"
                          class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                      </div>
                      <div>
                        <label class="block text-[11px] text-gray-500 dark:text-gray-400 mb-1">Valor máximo</label>
                        <input type="number"
                          [value]="valMax ?? ''"
                          (change)="onValMaxChange($any($event.target).value)"
                          placeholder="—"
                          class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                      </div>
                    </div>
                  }
                </div>
              }

              <!-- Regla condicional (solo tipos que la soportan) -->
              @if (showConditionalRules) {
                <div class="border-t border-gray-100 dark:border-gray-800 pt-4 space-y-3">

                  <label class="flex items-center justify-between cursor-pointer">
                    <span class="text-xs font-medium text-gray-600 dark:text-gray-400">Regla condicional</span>
                    <div class="relative">
                      <input type="checkbox" class="sr-only peer"
                        [checked]="condActive"
                        (change)="onCondActiveChange($any($event.target).checked)" />
                      <div class="w-9 h-5 bg-gray-200 dark:bg-gray-700 peer-checked:bg-brand-500 rounded-full transition-colors peer-focus:ring-2 peer-focus:ring-brand-500/30"></div>
                      <div class="absolute top-0.5 left-0.5 w-4 h-4 bg-white rounded-full shadow transition-transform peer-checked:translate-x-4"></div>
                    </div>
                  </label>

                  @if (condActive) {
                    <div class="space-y-3">

                      <!-- Acción -->
                      <div>
                        <p class="text-[11px] text-gray-500 dark:text-gray-400 mb-1.5">Acción</p>
                        <div class="flex gap-1">
                          @for (a of condActions; track a.value) {
                            <button type="button"
                              (click)="onCondActionChange(a.value)"
                              class="flex-1 py-1 rounded-lg text-[11px] font-medium transition-colors"
                              [class.bg-brand-500]="condRule.action === a.value"
                              [class.text-white]="condRule.action === a.value"
                              [class.bg-gray-100]="condRule.action !== a.value"
                              [class.dark:bg-gray-800]="condRule.action !== a.value"
                              [class.text-gray-600]="condRule.action !== a.value"
                              [class.dark:text-gray-400]="condRule.action !== a.value">
                              {{ a.label }}
                            </button>
                          }
                        </div>
                      </div>

                      <!-- Lógica (solo si hay más de una condición) -->
                      @if (condRule.conditions.length > 1) {
                        <div>
                          <p class="text-[11px] text-gray-500 dark:text-gray-400 mb-1.5">Lógica entre condiciones</p>
                          <div class="flex gap-1">
                            @for (l of condLogics; track l.value) {
                              <button type="button"
                                (click)="onCondLogicChange(l.value)"
                                class="flex-1 py-1 rounded-lg text-[11px] font-medium transition-colors"
                                [class.bg-brand-500]="condRule.logic === l.value"
                                [class.text-white]="condRule.logic === l.value"
                                [class.bg-gray-100]="condRule.logic !== l.value"
                                [class.dark:bg-gray-800]="condRule.logic !== l.value"
                                [class.text-gray-600]="condRule.logic !== l.value"
                                [class.dark:text-gray-400]="condRule.logic !== l.value">
                                {{ l.label }}
                              </button>
                            }
                          </div>
                        </div>
                      }

                      <!-- Filas de condición -->
                      <div class="space-y-2">
                        @for (cond of condRule.conditions; track $index; let i = $index) {
                          <div class="p-2.5 rounded-lg bg-gray-50 dark:bg-gray-800/60 space-y-2">

                            <select
                              (change)="onConditionFieldChange(i, $any($event.target).value)"
                              class="w-full px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition">
                              <option value="" [selected]="!cond.field_key">— Campo que dispara —</option>
                              @for (f of otherFields; track f.fieldKey) {
                                <option [value]="f.fieldKey" [selected]="f.fieldKey === cond.field_key">{{ f.label || f.fieldKey }}</option>
                              }
                            </select>

                            <div class="flex gap-1.5 items-start min-w-0">
                              <select
                                (change)="onConditionOperatorChange(i, $any($event.target).value)"
                                class="flex-1 min-w-0 px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition">
                                @for (op of condOperatorsFor(cond.field_key); track op.value) {
                                  <option [value]="op.value" [selected]="op.value === cond.operator">{{ op.label }}</option>
                                }
                              </select>

                              @if (needsValue(cond.operator)) {
                                @if (condTriggerHasOptions(cond.field_key)) {
                                  <select
                                    (change)="onConditionValueChange(i, $any($event.target).value)"
                                    class="flex-1 min-w-0 px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition">
                                    <option value="" [selected]="!cond.value">— Selecciona —</option>
                                    @for (opt of condTriggerOptions(cond.field_key); track opt.optionValue) {
                                      <option [value]="opt.optionValue" [selected]="opt.optionValue === (cond.value ?? '')">{{ opt.optionLabel }}</option>
                                    }
                                  </select>
                                } @else if (condTriggerIsNumber(cond.field_key)) {
                                  <input type="number"
                                    [value]="cond.value ?? ''"
                                    (input)="onConditionValueChange(i, $any($event.target).value)"
                                    placeholder="Valor"
                                    class="flex-1 min-w-0 px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                                } @else if (condTriggerIsDate(cond.field_key)) {
                                  <input type="date"
                                    [value]="cond.value ?? ''"
                                    (change)="onConditionValueChange(i, $any($event.target).value)"
                                    class="flex-1 min-w-0 px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                                } @else {
                                  <input type="text"
                                    [value]="cond.value ?? ''"
                                    (input)="onConditionValueChange(i, $any($event.target).value)"
                                    placeholder="Valor"
                                    class="flex-1 min-w-0 px-2.5 py-1.5 text-xs rounded-lg border border-gray-200 dark:border-gray-700 bg-white dark:bg-gray-800 text-gray-900 dark:text-white focus:outline-none focus:ring-2 focus:ring-brand-500 transition" />
                                }
                              }

                              @if (condRule.conditions.length > 1) {
                                <button type="button"
                                  (click)="removeCondition(i)"
                                  class="flex-shrink-0 w-6 h-6 flex items-center justify-center rounded-lg text-gray-400 hover:text-error-500 hover:bg-error-50 dark:hover:bg-error-500/10 transition-colors mt-0.5">
                                  <svg class="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12"/>
                                  </svg>
                                </button>
                              }
                            </div>

                          </div>
                        }
                      </div>

                      <!-- Warning condiciones inválidas -->
                      @if (invalidConditionCount > 0) {
                        <p class="text-[10px] text-amber-600 dark:text-amber-400 flex items-center gap-1">
                          <span>⚠</span>
                          {{ invalidConditionCount === 1
                            ? '1 condición sin campo o con operador incompatible no se guardará.'
                            : invalidConditionCount + ' condiciones sin campo o con operador incompatible no se guardarán.' }}
                        </p>
                      }

                      <!-- Agregar condición -->
                      <button type="button" (click)="addCondition()"
                        class="inline-flex items-center gap-1 text-xs font-medium text-brand-600 dark:text-brand-400 hover:text-brand-700 transition-colors">
                        <svg class="w-3.5 h-3.5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4"/>
                        </svg>
                        Agregar condición
                      </button>

                    </div>
                  }
                </div>
              }

            </div>
          }
        </div>
      }

    </div>
  }

  } <!-- end panelMode === 'field' -->
</div>
